<!--
 * $Description:特殊的列表，在业务操作中使用
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月10日 11:16:09 +0800
 * @最后修改时间: 2022-03-31 18:15:02
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_SpecialTable.vue
 -->
<template>
  <div>
    <v-sheet
      v-if="isHead"
      class="
        mx-auto
        pa-2
        flex-xl-grow-1
        d-flex
        flex-row
        justify-space-between
        align-center
      "
    >
      <div class="title">{{ title }}</div>
      <v-spacer></v-spacer>
      <div class="tools">
        <v-btn
          rounded
          small
          :disabled="readonly"
          v-if="addBtn"
          color="primary"
          @click="toAddGroup"
          class="text-capitalize ml-2 mr-2"
          outlined
        >
          <span class="material-icons-round">add</span>
          {{ $t(addBtn) }}
        </v-btn>
      </div>
    </v-sheet>
    <v-data-table
      :headers="headers"
      :items="items"
      :page.sync="page"
      item-key="uuid"
      fixed-header
      :hide-default-header="!show"
      :height="tableHeight"
      :loading="loading || Loading || isLoading"
      loading-text="Loading... Please wait"
      hide-default-footer
      :class="'elevation-' + elevation"
      class="rounded-lg"
      style="border: 1px solid #e1e1e1; overflow: hidden"
      :items-per-page="showFooter ? itemsPerPage : 1000"
      @page-count="$tableSetting.pageCount = $event"
      :elevation="0"
      :footer-props="{
        'items-per-page-options': [10, 20, 50],
        'items-per-page-text': $t(
          'label_essweb_list_components_pagenations_perpageLabel'
        ),
      }"
    >
      <template v-slot:no-data>
        <noContent v-if="show" />
      </template>
      <template
        v-for="it in headers"
        :slot="'header.' + it.value"
        slot-scope="{ header }"
      >
        <slot :name="'header.' + it.value" :header="header">
          <div
            class="text-body-2 table-header-color"
            :style="{
              minWidth: it.width
                ? it.width + 'px  !important'
                : '100px !important',
            }"
            :key="it.value"
          >
            {{ $t(it.text) }}
          </div>
        </slot>
      </template>
      <template v-if="tableTitle != ''" v-slot:top>
        <div
          class="
            mx-auto
            pa-2
            d-flex
            flex-row
            justify-space-between
            align-center
          "
          height="50"
          :style="{ borderBottom: show ? '1px solid #e1e1e1' : 'none' }"
        >
          <div class="subtitle-1 text--secondary text--lighten--3">
            {{ $getCommonLangValue(tableTitle) }}
          </div>
          <v-spacer></v-spacer>
          <div
            class="tools"
            v-if="type != 'shift' && type != 'staff' && type != 'manage'"
          >
            <v-btn
              icon
              :disabled="readonly"
              @click="toEditGroup()"
              v-if="type != 'site' && !readonly"
            >
              <span class="material-icons-round">edit</span>
            </v-btn>
            <v-btn
              icon
              :disabled="readonly"
              @click="toDeleteGroup()"
              v-if="!readonly"
            >
              <span class="material-icons-round">delete</span>
            </v-btn>
            <v-btn icon @click.stop="show = !show">
              <span class="material-icons-round">unfold_less</span>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-if="type == 'face'" v-slot:item.face_name="{ item }">{{
        $getCommonLangValue(item.criteria_facial_name)
      }}</template>
      <template v-if="type == 'face'" v-slot:item.face_simi="{ item }">
        {{ item.facial_recognition_similarity }}
      </template>
      <template v-if="type == 'face'" v-slot:item.face_status="{ item }">
        <v-chip
          small
          :color="Number(item.status) === 1 ? 'green' : 'blue-grey lighten-2'"
          >{{
            Number(item.status) === 1
              ? $t("label_essweb_system_status_onLabel")
              : $t("label_essweb_system_status_offLabel")
          }}
        </v-chip>
      </template>
      <template v-if="type == 'gps'" v-slot:item.gps_name="{ item }"
        >{{ $getCommonLangValue(item.criteria_gps_name) }}
      </template>
      <template v-if="type == 'gps'" v-slot:item.gps_dis="{ item }"
        >{{ item.within_distance_meter }}
      </template>
      <template v-if="type == 'gps'" v-slot:item.gps_status="{ item }">
        <v-chip
          small
          :color="Number(item.status) === 1 ? 'green' : 'blue-grey lighten-2'"
          >{{
            Number(item.status) === 1
              ? $t("label_essweb_system_status_onLabel")
              : $t("label_essweb_system_status_offLabel")
          }}
        </v-chip>
      </template>
      <template v-if="type == 'wifi'" v-slot:item.wifi_name="{ item }"
        >{{ $getCommonLangValue(item.criteria_wifi_name) }}
      </template>
      <template v-if="type == 'wifi'" v-slot:item.wifi_site="{ item }"
        >{{ item.site_uuid }}
      </template>
      <template v-if="type == 'wifi'" v-slot:item.wifi_ip="{ item }"
        >{{ item.ssid }}
      </template>
      <template v-if="type == 'wifi'" v-slot:item.wifi_status="{ item }">
        <v-chip
          small
          :color="Number(item.status) === 1 ? 'green' : 'blue-grey lighten-2'"
          >{{
            Number(item.status) === 1
              ? $t("label_essweb_system_status_onLabel")
              : $t("label_essweb_system_status_offLabel")
          }}
        </v-chip>
      </template>
      <template
        v-if="type == 'bluetooth'"
        v-slot:item.bluetooth_name="{ item }"
      >
        {{ $getCommonLangValue(item.criteria_bluetooth_name) }}
      </template>
      <template
        v-slot:item.bluetooth_site="{ item }"
        v-if="type == 'bluetooth'"
      >
        {{ item.site_uuid }}
      </template>
      <template v-if="type == 'bluetooth'" v-slot:item.bluetooth_ip="{ item }">
        {{ item.bluetooth_device_uuid }}
      </template>
      <template
        v-if="type == 'bluetooth'"
        v-slot:item.bluetooth_status="{ item }"
      >
        <v-chip
          small
          :color="Number(item.status) === 1 ? 'green' : 'blue-grey lighten-2'"
          >{{
            Number(item.status) === 1
              ? $t("label_essweb_system_status_onLabel")
              : $t("label_essweb_system_status_offLabel")
          }}</v-chip
        >
      </template>
      <template v-if="type == 'staff'" v-slot:item.staff_id="{ item }">
        {{ item.staff_code }}
      </template>
      <template v-if="type == 'staff'" v-slot:item.staff_name="{ item }">
        {{ $getCommonLangValue(item.preferred_name) }}
        <span class="text--secondary text-caption-xs">
          {{ item.staff_code }}</span
        >
      </template>
      <template v-if="type == 'manage'" v-slot:item.staffid="{ item }">
        {{ item.staff_id }}
      </template>
      <template v-if="type == 'manage'" v-slot:item.staff_name="{ item }">
        {{ $getCommonLangValue(item.preferred_name) }}
        <span class="text--secondary text-caption-xs">
          {{ item.staff_code }}</span
        >
      </template>
      <template v-if="type == 'shift'" v-slot:item.shift_name="{ item }">
        {{ $getCommonLangValue(item.shift_name) }}
      </template>
      <template v-if="type == 'site'" v-slot:item.name="{ item }">
        {{
          item.criteria
            ? item.criteriaType.punch_code == "FACE"
              ? $getCommonLangValue(item.criteria.criteria_facial_name)
              : item.criteriaType.punch_code == "WIFI"
              ? $getCommonLangValue(item.criteria.criteria_wifi_name)
              : item.criteriaType.punch_code == "GPS"
              ? $getCommonLangValue(item.criteria.criteria_gps_name)
              : item.criteriaType.punch_code == "BLUETOOTH"
              ? $getCommonLangValue(item.criteria.criteria_bluetooth_name)
              : ""
            : "Null"
        }}
      </template>
      <template v-if="type == 'site'" v-slot:item.type="{ item }">
        {{ $getCommonLangValue(item.criteriaType.criteria_type_name) }}
      </template>
      <template v-slot:item.time="{ item }">
        <div class="text--primary">{{ item.time.time }}</div>
      </template>
      <template v-slot:item.status="{ item }">
        <template v-if="type == 'other1' || type == 'other2'">
          {{ $t(item.status) }}
        </template>
      </template>
      <template v-if="type == 'shift'" v-slot:item.shifttime="{ item }">{{
        $timeMachine(item.start_utc_time) +
        "--" +
        $timeMachine(item.end_utc_time)
      }}</template>
      <template v-slot:footer="{ props }">
        <Pagenations
          v-if="showFooter && items.length > 10 && show"
          :options="props"
          :filterpage="page"
          :local-loading="Loading"
          :filterItemsPerPage="itemsPerPage"
          @change="onChange"
          :items="totalCount !== undefined ? totalCount : items"
        />
        <div
          class="
            mx-auto
            pa-2
            d-flex
            flex-row
            justify-space-between
            align-center
          "
          height="50"
          v-if="show && !readonly"
          :style="{ borderTop: !show ? '' : '1px solid #e1e1e1' }"
        >
          <div class="tools">
            <v-btn
              text
              color="primary"
              :disabled="readonly"
              v-if="newBtn != '' && !readonly"
              @click="toNew"
              class="text-capitalize"
            >
              {{
                $t("label_essweb_special_tale_addBtnLabel") +
                (isNeedSpace ? " " : "") +
                $t(newBtn)
              }}
              <span class="material-icons-round">add</span>
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <div></div>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <template
          v-if="
            type == 'staff' ||
            type == 'shift' ||
            type == 'manage' ||
            type == 'site'
          "
        >
          <v-btn
            icon
            @click="toDelete(item)"
            :disabled="readonly"
            v-if="!readonly"
          >
            <span class="material-icons-round">delete</span>
          </v-btn>
        </template>
        <template v-else>
          <v-btn icon @click="toEdit(item)">
            <span class="material-icons-round">edit</span>
          </v-btn>
          <v-btn icon @click="toDelete(item)">
            <span class="material-icons-round">delete</span>
          </v-btn>
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SpecialTable",
  props: {
    isHead: { default: false, type: Boolean },
    readonly: { default: false, type: Boolean },
    loading: { default: false, type: Boolean },
    type: { default: "", type: String },
    items: { default: [], type: Array },
    avPerPage: { default: 0, type: [Number, String] },
    type_uuid: { default: "", type: String },
    totalCount: { default: undefined, type: [String, Number] },
    group_type_uuid: { default: "", type: String },
    title: { default: "", type: String },
    tableTitle: { default: "", type: [String, Array] },
    addBtn: { default: "", type: String },
    newBtn: { default: "", type: String },
    headers: { default: [], type: Array },
    height: { default: "100%", type: [String, Number] },
    showFooter: { default: false, type: Boolean },
    elevation: { default: 0, type: Number },
  },
  computed: {
    ...mapGetters(["isNeedSpace", "isLoading"]),
    tableHeight() {
      if (this.show) {
        return this.height;
      } else {
        return 0;
      }
    },
  },
  data() {
    return {
      Loading: false,
      itemsPerPage: 0,
      page: 1,
      show: false,
    };
  },
  mounted() {
    this.itemsPerPage = this.avPerPage
      ? this.avPerPage
      : this.$tableSetting.perPageSize;
  },
  methods: {
    onChange: function (page, perPage) {
      if (this.Loading) return;
      const that = this;
      this.Loading = true;
      if (this.totalCount !== undefined) {
        this.Loading = true;
        this.$emit(
          "change",
          page,
          perPage,
          (page, perPage) => {
            that.$Sleep(2000).then(() => {
              if (page !== undefined) that.page = page;
              if (perPage !== undefined) that.itemsPerPage = perPage;
              that.Loading = false;
            });
          },
          this.filterData
        );
        that.$Sleep(6000).then(() => {
          if (that.Loading) that.Loading = false; //超时
        });
      }

      that.$Sleep(1000).then(() => {
        if (page !== undefined) that.page = page;
        if (perPage !== undefined) that.itemsPerPage = perPage;
        if (this.totalCount === undefined) {
          that.Loading = false;
        }
      });
    },
    toAddGroup: function () {
      this.$emit("onAdd", this.type);
    },
    toEditGroup: function () {
      this.$emit("onEditGroup");
    },
    toDeleteGroup: function () {
      this.$emit("onDeleteGroup");
    },
    toNew: function () {
      this.$emit("onNew", this.type, this.type_uuid, this.group_type_uuid);
    },
    toEdit: function (item) {
      this.$emit(
        "onEdit",
        this.type,
        item,
        this.type_uuid,
        this.group_type_uuid
      );
    },
    toDelete: function (item) {
      this.$emit(
        "onDelete",
        this.type,
        item,
        this.type_uuid,
        this.group_type_uuid
      );
    },
  },
};
</script>
